export default __webpack_public_path__ + "9d858d1a3ab57f8ee2e19d1e7a6dd05d.svg";